import {InfoBoxComponent} from './component';
import {inject, IReactComponent} from 'mobx-react';

import './styles.scss';

const mapStoresToProps = (stores: any) => ({
    translate: stores.inviteStore?.localizationService?.translate?.bind(stores.inviteStore.localizationService)
});

const BoxInfoComponent = inject(mapStoresToProps)(InfoBoxComponent) as IReactComponent;

export default BoxInfoComponent;
